<div>
    <div class="flex justify-content-between align-items-center gap-3 mb-3">
        <div class="flex align-items-center gap-2">
            <h2 class="section-title m-0">{{ 'settings.users.title' | translate }}</h2>
            <span
                class="material-symbols-outlined icon-sm text-color-secondary cursor-help"
                [pTooltip]="'settings.users.subTitle' | translate"
                >info</span
            >
        </div>
        @if (canAdd && addingEditingMode === false) {
            <p-button [label]="'settings.users.button.add' | translate" icon="ms ms-add" (onClick)="addEditUser()" />
        }
    </div>
    @if (addingEditingMode === false) {
        <div>
            @if (!isLoading && pricingPlan && usersList) {
                <p>
                    {{
                        'settings.users.remaining'
                            | translatePlural: pricingPlan.licenseDoc.max_users - usersList.length
                            | translate
                                : {
                                      actual: usersList.length,
                                      max: pricingPlan.licenseDoc.max_users,
                                      remaining: pricingPlan.licenseDoc.max_users - usersList.length,
                                  }
                    }}
                </p>
            }
            <div class="card">
                <!-- While (re)loading, the skeleton replaces the rows: the stale list never flashes -->
                <p-table
                    [value]="isLoading ? [] : usersList"
                    [loading]="isLoading"
                    [showLoader]="false"
                    [paginator]="true"
                    [alwaysShowPaginator]="false"
                    [rows]="10">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 20%" pSortableColumn="firstname">
                                {{ 'settings.users.list.name' | translate }}
                                <p-sortIcon field="firstname" />
                            </th>
                            <th style="width: 30%" pSortableColumn="email">
                                {{ 'settings.users.list.email' | translate }}
                                <p-sortIcon field="email" />
                            </th>
                            <th>{{ 'settings.users.list.profile' | translate }}</th>
                            <th>{{ 'settings.users.list.latestConnexion' | translate }}</th>
                            <th class="col-actions"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-user>
                        <tr>
                            <td class="font-medium">{{ user.firstname }} {{ user.lastname }}</td>
                            <td>{{ user.email }}</td>
                            <td>{{ getRoleNameLabel(user.roles) | translate }}</td>
                            <td>{{ getRoleLastConnexion(user.roles) }}</td>
                            <td class="col-actions">
                                <p-button
                                    icon="ms ms-edit"
                                    [text]="true"
                                    [rounded]="true"
                                    size="small"
                                    [ariaLabel]="'components.settingsForm.button.edit' | translate"
                                    [pTooltip]="'components.settingsForm.button.edit' | translate"
                                    (onClick)="addEditUser(user)" />
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="loadingbody">
                        @for (row of [1, 2, 3]; track row) {
                            <tr>
                                <td><p-skeleton width="70%" /></td>
                                <td><p-skeleton width="80%" /></td>
                                <td><p-skeleton width="50%" /></td>
                                <td><p-skeleton width="60%" /></td>
                                <td class="col-actions"></td>
                            </tr>
                        }
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="5">
                                <div class="empty-state empty-state--compact">{{ 'common.noData' | translate }}</div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    } @else {
        <app-edit-user
            [user]="selectedUser"
            [orgId]="orgId"
            [isOrgOwner]="isOrgOwner"
            [isLastUser]="usersList.length <= 1"
            [isLastMainUser]="selectedUserIsLastMainUser"
            (closeEditUser)="oncloseEditUser($event)"></app-edit-user>
    }
</div>
